module.exports = __webpack_public_path__ + "static/the-spy-and-the-traitor-bb4bd7e3fa60f265bad74597854e65d6.jpg";